import revive_payload_client_4sVQNw7RlN from "/var/www/salamis-front-2/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/salamis-front-2/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/salamis-front-2/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/salamis-front-2/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/var/www/salamis-front-2/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/var/www/salamis-front-2/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/salamis-front-2/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_gab9g3XuEx from "/var/www/salamis-front-2/node_modules/nuxt-aos/dist/runtime/plugin.js";
import composition_sLxaNGmlSL from "/var/www/salamis-front-2/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/var/www/salamis-front-2/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_tbFNToZNim from "/var/www/salamis-front-2/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/var/www/salamis-front-2/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/var/www/salamis-front-2/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import asksuite_chat_client_AbzWAhysg9 from "/var/www/salamis-front-2/plugins/asksuite-chat.client.ts";
import og_from_page_meta_gMy1LXnH6g from "/var/www/salamis-front-2/plugins/og-from-page-meta.ts";
import reveal_HNCBkNtIz6 from "/var/www/salamis-front-2/plugins/reveal.ts";
import smart_app_banner_client_qPro4u4zju from "/var/www/salamis-front-2/plugins/smart-app-banner.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_gab9g3XuEx,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  plugin_tbFNToZNim,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  asksuite_chat_client_AbzWAhysg9,
  og_from_page_meta_gMy1LXnH6g,
  reveal_HNCBkNtIz6,
  smart_app_banner_client_qPro4u4zju
]